export default __webpack_public_path__ + "static/media/icon_logo.a2d30bbd.svg";